"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectionRangeTypes = void 0;
/**
 * Types of Selection Ranges that the SelectionRangeEx can return
 */
var SelectionRangeTypes;
(function (SelectionRangeTypes) {
    /**
     * Normal selection range provided by browser.
     */
    SelectionRangeTypes[SelectionRangeTypes["Normal"] = 0] = "Normal";
    /**
     * Selection made inside of a single table.
     */
    SelectionRangeTypes[SelectionRangeTypes["TableSelection"] = 1] = "TableSelection";
})(SelectionRangeTypes = exports.SelectionRangeTypes || (exports.SelectionRangeTypes = {}));
//# sourceMappingURL=SelectionRangeTypes.js.map